import { RollingDateDisplayType } from '../DisplayTypes';
import { RollingDateInputType } from '../InputTypes';
import { TODAY } from '../rollingDates/RollingDateOptionValues';
import { makeOperator } from './Operator';
import RollingDateConfig, { validateRollingDateConfig } from '../rollingDates/RollingDateConfig';
import isNumber from 'transmute/isNumber';
export default makeOperator({
  displayType: RollingDateDisplayType,
  inputType: RollingDateInputType,
  name: 'InDynamicDateRange',
  values: [{
    defaultValue: RollingDateConfig.fromRollingDateOptionValue(TODAY),
    isIterable: false,
    // @ts-expect-error ts-migrate(2322) FIXME: Type '(opts?: RollingDateConfigType | {}) => boole... Remove this comment to see the full error message
    isValid: validateRollingDateConfig,
    name: 'value'
  }, {
    defaultValue: 0,
    isValid: isNumber,
    name: 'rollingOffset'
  }]
});